import { Component } from '@angular/core';
import { MaterialModule } from '../../../../../Material-Module';
import { CommonModule } from '@angular/common';
import { MainNavbarComponent } from '../../../../core/components/main-navbar/main-navbar.component';
import { CustomSearchComponent } from '../custom-search/custom-search.component';
import { CombinedSearchComponent } from '../combined-search/combined-search.component';

@Component({
  selector: 'app-thematic-home',
  standalone: true,
  imports: [MaterialModule, CommonModule, MainNavbarComponent, CustomSearchComponent, CombinedSearchComponent],
  templateUrl: './thematic-home.component.html',
  styleUrl: './thematic-home.component.css'
})
export class ThematicHomeComponent {
  thematic_search_type: string = 'combined_search';

  selectThemeSearchType(type: string) {
    this.thematic_search_type = type;
  }
}
